import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" };
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "modal-header" };
const _hoisted_4 = { class: "modal-title" };
const _hoisted_5 = { class: "modal-body" };
const _hoisted_6 = {
    key: 0,
    class: "text-center text-muted py-4"
};
const _hoisted_7 = {
    key: 0,
    class: "alert alert-danger py-2 small"
};
const _hoisted_8 = {
    key: 0,
    class: "text-muted small mb-0"
};
const _hoisted_9 = {
    key: 1,
    class: "table-responsive"
};
const _hoisted_10 = { class: "table table-sm table-striped align-middle mb-0" };
const _hoisted_11 = { class: "small" };
const _hoisted_12 = { class: "fw-medium" };
const _hoisted_13 = { class: "small text-break" };
const _hoisted_14 = { class: "small text-nowrap" };
const _hoisted_15 = {
    key: 1,
    class: "modal-backdrop fade show encuesta-resultados-backdrop"
};
import { computed, ref, watch } from "vue";
import { fetchSurveyResults } from "@/services/surveyService";
import { formatSurveyAnswerDisplay, formatSurveyCourseLabel, } from "@/utils/surveyResultsDisplay";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EncuestaResultadosModal',
    props: {
        show: { type: Boolean },
        survey: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const cargando = ref(false);
        const errorCarga = ref("");
        const datos = ref(null);
        const nombreCurso = (courseCode) => {
            return formatSurveyCourseLabel(courseCode);
        };
        /** Año-mes-día hora:minuto (24 h), p. ej. 2026-04-14 19:19 */
        const formatearFecha = (iso) => {
            if (!iso)
                return "—";
            try {
                const d = new Date(iso);
                if (Number.isNaN(d.getTime()))
                    return iso;
                const y = d.getFullYear();
                const m = String(d.getMonth() + 1).padStart(2, "0");
                const day = String(d.getDate()).padStart(2, "0");
                const h = String(d.getHours()).padStart(2, "0");
                const min = String(d.getMinutes()).padStart(2, "0");
                return `${y}-${m}-${day} ${h}:${min}`;
            }
            catch {
                return iso;
            }
        };
        const textoRespuestas = (row) => {
            const parts = (row.answers ?? [])
                .map((answer) => {
                const question = props.survey?.questions?.find((item) => item.questionId === answer.questionId);
                return formatSurveyAnswerDisplay(row, question);
            })
                .filter((value) => value && value !== "—");
            return parts.length ? parts.join(" · ") : "—";
        };
        const filasOrdenadas = computed(() => {
            const list = datos.value?.responses ?? [];
            return [...list].sort((a, b) => {
                const c = (a.courseCode || "").localeCompare(b.courseCode || "", "es");
                if (c !== 0)
                    return c;
                return (a.schoolId || "").localeCompare(b.schoolId || "", "es");
            });
        });
        const cargar = async () => {
            if (!props.survey)
                return;
            errorCarga.value = "";
            datos.value = null;
            cargando.value = true;
            try {
                datos.value = await fetchSurveyResults(props.survey.surveyId);
            }
            catch (e) {
                errorCarga.value =
                    mensajeError(e) ||
                        "No se pudieron cargar los resultados. Es posible que no tengas permiso para verlos.";
            }
            finally {
                cargando.value = false;
            }
        };
        const mensajeError = (e) => {
            if (typeof e === "object" && e !== null && "response" in e) {
                const res = e.response;
                const data = res?.data;
                if (typeof data?.message === "string" && data.message)
                    return data.message;
                if (data?.error &&
                    typeof data.error === "object" &&
                    typeof data.error.message === "string") {
                    return data.error.message;
                }
            }
            return "";
        };
        watch(() => [props.show, props.survey?.surveyId], ([abierto]) => {
            if (abierto && props.survey) {
                cargar();
            }
        });
        const emitClose = () => {
            emit("close");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.show && _ctx.survey)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal fade show encuesta-resultados-modal",
                        style: { "display": "block" },
                        tabindex: "-1",
                        onClick: _withModifiers(emitClose, ["self"])
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("h5", _hoisted_4, [
                                        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-bar-chart-line me-2" }, null, -1)),
                                        _createTextVNode(" Resultados — " + _toDisplayString(_ctx.survey.title), 1)
                                    ]),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "aria-label": "Cerrar",
                                        onClick: emitClose
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    (cargando.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
                                            _createElementVNode("span", {
                                                class: "spinner-border spinner-border-sm me-2",
                                                role: "status"
                                            }, null, -1),
                                            _createTextVNode(" Cargando resultados… ")
                                        ])))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (errorCarga.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(errorCarga.value), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("section", null, [
                                                _cache[3] || (_cache[3] = _createElementVNode("h6", { class: "text-secondary text-uppercase small mb-2" }, " Respuestas por curso ", -1)),
                                                (!filasOrdenadas.value.length)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Aún no hay respuestas registradas para esta encuesta. "))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                        _createElementVNode("table", _hoisted_10, [
                                                            _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                                                                _createElementVNode("tr", null, [
                                                                    _createElementVNode("th", { scope: "col" }, "Curso"),
                                                                    _createElementVNode("th", { scope: "col" }, "Respuesta"),
                                                                    _createElementVNode("th", { scope: "col" }, "Fecha de envío")
                                                                ])
                                                            ], -1)),
                                                            _createElementVNode("tbody", null, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filasOrdenadas.value, (row) => {
                                                                    return (_openBlock(), _createElementBlock("tr", {
                                                                        key: row.responseId
                                                                    }, [
                                                                        _createElementVNode("td", _hoisted_11, [
                                                                            _createElementVNode("span", _hoisted_12, _toDisplayString(nombreCurso(row.courseCode)), 1)
                                                                        ]),
                                                                        _createElementVNode("td", _hoisted_13, _toDisplayString(textoRespuestas(row)), 1),
                                                                        _createElementVNode("td", _hoisted_14, _toDisplayString(formatearFecha(row.submittedAt)), 1)
                                                                    ]));
                                                                }), 128))
                                                            ])
                                                        ])
                                                    ]))
                                            ])
                                        ], 64))
                                ]),
                                _createElementVNode("div", { class: "modal-footer" }, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-secondary",
                                        onClick: emitClose
                                    }, " Cerrar ")
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.show && _ctx.survey)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
